module.exports = __webpack_public_path__ + "static/media/Sun.9c929adf.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Sun.png
// module id = 57
// module chunks = 0